let owner = 0;
let writes: Promise<unknown> = Promise.resolve();

export function currentAuthOwner(): number {
  return owner;
}

export function beginAuthOwner(): number {
  return ++owner;
}

export function assertAuthOwner(ticket: number): void {
  if (ticket !== owner) {
    throw new Error('Your sign-in session changed. Please try again.');
  }
}

export async function waitForAuthCookies(ticket: number): Promise<void> {
  await writes;
  assertAuthOwner(ticket);
}

// A response can apply HttpOnly cookies before JavaScript sees it. Drain the old
// writer before dispatching a newer one; a state-only generation fence is too late.
export function writeAuthCookies<T>(
  ticket: number,
  write: () => Promise<T>
): Promise<T> {
  const result = writes.then(async () => {
    assertAuthOwner(ticket);
    const value = await write();
    assertAuthOwner(ticket);
    return value;
  });
  writes = result.catch(() => undefined);
  return result;
}
